export const MarketingPage = () => {
  return (
    <div className="marketing-page-background h-screen w-screen">
      <div className="mx-auto flex size-full max-w-[560px] flex-col items-center overflow-hidden">
        {/* <Image
			  src="/images/patchooli-wordart.png"
			  alt="Marketing Page"
			  width={560}
			  height={560}
			  priority
			/> */}
        <img src="/images/patchooli-wordart.png" alt="Marketing Page" width={560} height={560} />
        <div className="flex w-full -translate-y-1/2 items-center justify-center backdrop-blur-md">
          <h1 className="text-marketing-page-foreground text-2xl font-bold">Coming Soon!</h1>
        </div>
      </div>
    </div>
  );
};
